import { Navigate, Route, Routes } from "react-router-dom";
import SelectAccount from "./signup/SelectAccount";
import BVNVerfication from "./signup/BVNVerification";
import { createContext, useState } from "react";
import CompleteProfile from "./signup/CompleteProfile";
import PageNotFound from "./PageNotFound";
import ValidateEmailOtp from "./signup/ValidateEmailOtp";
import CreatePassword from "./signup/CreatePassword";
import ResumeProfileOtp from "./signup/ResumeProfileOtp";
import VerifyNIN from "./verify/VerifyNIN";
import VerifyPhoneNumber from "./verify/VerifyPhoneNumber";
import ContactPhoneVerification from "./verify/ContactPhoneVerification";
import OnboardingSuccess from "./signup/OnboardingSuccess";
import ConfirmResidence from "./signup/ConfirmResidence";
import NationalIdentity from "./signup/NationalIdentity";

export const SignUpContext = createContext<{
  accountType: "personal" | "business";
  businessType: "sole" | "corporation";
  setAccountType: React.Dispatch<React.SetStateAction<"personal" | "business">>;
  setBusinessType: React.Dispatch<React.SetStateAction<"sole" | "corporation">>;
}>({
  businessType: "sole",

  accountType: "personal",
  setAccountType: () => {
    // do nothing
  },
  setBusinessType: () => {
    // do nothing
  },
});

const SignUp = () => {
  const [accountType, setAccountType] = useState<"personal" | "business">(
    "personal"
  );

  const [businessType, setBusinessType] = useState<"sole" | "corporation">(
    "sole"
  );

  return (
    <SignUpContext.Provider
      value={{
        accountType,
        setAccountType,
        businessType,
        setBusinessType,
      }}
    >
      <Routes>
        <Route path="/" element={<SelectAccount />} />
        <Route path="/contact-phone" element={<ContactPhoneVerification />} />
        <Route path="/confirm-residence" element={<ConfirmResidence />} />
        <Route path="/verify-nin" element={<VerifyNIN />} />
        <Route path="/national-identity" element={<NationalIdentity />} />
        {/* Old links must not revive address collection during signup. */}
        <Route path="/home-address" element={<Navigate to="/sign-up/confirm-residence" replace />} />
        <Route path="/verify-phone-number" element={<VerifyPhoneNumber />} />
        <Route path="/create-password" element={<CreatePassword />} />
        {/* Username and profile photo left signup; they are dashboard tasks now. */}
        <Route path="/choose-username" element={<Navigate to="/sign-up/create-password" replace />} />
        <Route path="/bvn-verification" element={<BVNVerfication />} />
        <Route path="/email-otp" element={<ValidateEmailOtp />} />
        <Route path="/resume-profile-otp" element={<ResumeProfileOtp />} />
        <Route path="/complete-profile" element={<CompleteProfile />} />
        <Route path="/upload-profile-image" element={<Navigate to="/home" replace />} />
        <Route path="/success" element={<OnboardingSuccess />} />
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </SignUpContext.Provider>
  );
};

export default SignUp;
